import React from 'react';
import { connect } from 'react-redux';

import { setActiveHook } from '../stores/reducers/UI/actions';
import { getActiveHook } from '../stores/reducers';

import SiteWrapper from '../components/SiteWrapper';
import LandingPage from '../components/LandingPage';

const mapStateToProps = state => ({
  activeHook: getActiveHook(state),
});
const WrappedLandingPage = connect(
  mapStateToProps,
  {
    onSetActiveHook: setActiveHook,
  }
)(LandingPage);

const IndexPage = () => (
  <SiteWrapper>
    {({ flavour }) => <WrappedLandingPage {...flavour} />}
  </SiteWrapper>
);

export default IndexPage;
